import React, { Component } from "react";
import classes from "./daybook.module.css";
import axios from "../../../axios-order";
import ErrorIcon from "@material-ui/icons/Error";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Card from "../../../components/ui/Cards";
import PublishIcon from "@material-ui/icons/Publish";
import GetAppIcon from "@material-ui/icons/GetApp";
import DataTables from "material-ui-datatables";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import daybookzoho from "../../../asserts/templates/day_book_.xlsx";
import ClearIcon from "@material-ui/icons/Clear";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import BoxWrapper from "../../../components/ui/boxWrapper";
import RefreshIcon from "@mui/icons-material/Refresh";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import BusinessIcon from "@mui/icons-material/Business"; // For Zoho
import CalculateIcon from "@mui/icons-material/Calculate"; // For Tally
import ZohoModel from "../../../components/ZohoModel/ZohoModel";
import moment from "moment";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { withRouter } from 'react-router-dom';

class DaybookManagement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            effitracCol: [
                {
                    key: "date",
                    render: (index, row) => row["date"],
                },
                {
                    key: "voucherType",
                    render: (index, row) => row["voucher_type"],
                },
                {
                    key: "typeOfVoucher",
                    render: (index, row) => row["type_of_voucher"],
                },
                {
                    key: "voucherID",
                    render: (index, row) => row["voucher_id"],
                },
                {
                    key: "voucherNo",
                    render: (index, row) => row["voucher_no"],
                },
                {
                    key: "lineID",
                    render: (index, row) => row["line_id"],
                },
                {
                    key: "ledgerName",
                    render: (index, row) => row["ledger_name"],
                },
            ],
            effitracData: null,
            oldEffitracData: null,
            effitracHeader: [
                { label: "Date" },
                { label: "Voucher Type" },
                { label: "Type of Voucher" },
                { label: "Voucher ID" },
                { label: "Voucher No" },
                { label: "Line ID" },
                { label: "Ledger Name" },
            ],
            actionHeaderForZoho: [
                { id: "cust_contact_name", name: "Contact Name" },
                { id: "cust_contact_email", name: "Contact Email" },
                { id: "cust_contact_no", name: "Contact No" },
                { id: "cust_address", name: "Address" },
                { id: "cust_state", name: "State" },
                { id: "cust_country", name: "Country" },
                { id: "cust_acctmgr_name", name: "Account Manager Name" },
                { id: "cust_acctmgr_email", name: "Account Manager Email" },
                { id: "cust_credit_limit", name: "Credit Limit" },
                { id: "cust_credit_days", name: "Credit Days" },
                { id: "cust_registration_type", name: "Registration Type" },
                { id: "TDS %", name: "tds_percentage" },
            ],
            read_only: "",
            next: {},
            prev: {},
            file_value: null,
            total_records: 0,
            successful_records: 0,
            errorPage: 1, // Current page
            perErrorPages: 10, // Records per page
            errortotal: 0, // Total records
            error_records: 0,
            error_rows: {},
            sellerCustomerCol: [
                {
                    label: "GSTIN",
                    render: (name, all) => all["record"]["GSTIN"],
                },
                {
                    label: "Invoice Number",
                    render: (name, all) => all["record"]["InvoiceNo"],
                },
                { key: "row", label: "Row #" },
                {
                    label: "Errors",
                    render: (name, all) => {
                        return Object.keys(all["errors_in"]).map((i, v) => (
                            <div style={{ whiteSpace: "pre-wrap" }}>
                                <span>{i}</span> <span>:</span>{" "}
                                <span style={{ color: "red" }}>
                                    {all["errors_in"][i].join(",")}
                                </span>
                            </div>
                        ));
                    },
                },
            ],
            sellerCustomerData: [],
            error: null,
            allArcCustomerData: [],
            OriginalDataAllArcCustomerData: [],
            showDrawer: false,
            showData: {},
            showUploadData: false,
            add_DrawerOpen: false,
            addCustomerData: {},
            edit_DrawerOpen: false,
            editCustomerData: {},
            openZohoDrawer: false,
            messageForConnection: "Establish Connection",
            buttonColor: "red",
            grantToken: "",
            url: window.location.origin, // Initialize with current origin
            zohoDate: {},
            openImportEffitracDrawer: false,
            importEffitracFetchData: {},
            effitracFetchedRecords: {},
            isExportingDaybook: false,
            fetrac: "",
            actions: [
                {
                    label: "Show",
                    onclickEvent: (index, row) => this.openModal(index),
                },
            ],
            effitracInvShow: false,
            autoSync: false,
            targetId: null,
            page: 0,
            rowsPerPage: 25,
            rowCount: 0,
            searchInput: "",
            uploadHistoryTableData: [],
            flagForZohoInSalesCustomer: false,
            timer: 60,
            isOpenUpdateTanModal: false,
            updateTanGetApiData: {},
            isLoaderforupdateTanButton: false,
            erpConnectorModelOpen: false,
            erpConnectorName: "",
            erpDataExportLoading: false,
            importToCwsLoading: false,
            snackbarOpen: false,
            snackbarMessage: "",
            snackbarSeverity: "success",
            selectedDaybookType: "Zoho",
            zohoFlag: 1, // Moved flagForZoho to state
            timerId: null, // Moved variableForTimer to state
        };
    }

    openModal = (index) => {
        this.setState(
            {
                targetId: index,
            },
            () => {
                this.setState({
                    effitracInvShow: true,
                });
            }
        );
    };

    handleAutoSyncChange = (checked) => {
        this.setState({ autoSync: checked });
    };

    handlePageChange = (newPage) => {
        console.log('Page change requested:', newPage);
        this.setState({ page: newPage, loading: true }, () => {
            this.uploadReport(this.props.id, newPage, this.state.perPage);
        });
    };

    handleNextPage = (event) => {
        const { errorPage, perErrorPages, errortotal } = this.state;
        const totalPages = Math.ceil(errortotal / perErrorPages);

        if (errorPage < totalPages) {
            const newPage = errorPage + 1;
            console.log(`Navigating to page ${newPage}`);
            this.setState({ errorPage: newPage }, () => {
                // Don't pass ID, let uploadReport get it from localStorage
                this.uploadReport(null, newPage);
            });
        }
    };
    

    handlePreviousPage = (event) => {
        const { errorPage } = this.state;

        if (errorPage > 1) {
            const newPage = errorPage - 1;
            console.log(`Navigating to page ${newPage}`);
            this.setState({ errorPage: newPage }, () => {
                // Don't pass ID, let uploadReport get it from localStorage
                this.uploadReport(null, newPage);
            });
        }
    };

    handleRowsPerPageChange = (index, value) => {
        console.log(`Changing rows per page to ${value}`);
        this.setState(
            {
                perErrorPages: value,
                errorPage: 1,
            },
            () => {
                // Don't pass ID, let uploadReport get it from localStorage
                this.uploadReport(null, 1);
            }
        );
    };

    closeEffitracInvShowHandler = () => {
        this.setState({
            effitracInvShow: false,
            targetId: null,
        });
    };

    handleSnackbarClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        this.setState({ snackbarOpen: false });
    };

    getHistoryTableUploadData = async () => {
        try {
            const response = await axios.get(
                `/arc/get_data_upload_history/${localStorage.getItem("business_entity_id")}/21`
            );
            const data = response?.data?.record || [];
            if (data.length > 0) {
                localStorage.setItem("upload_history_id", data[0].id);
            }
            this.setState({
                uploadHistoryTableData: data,
                snackbarOpen: false,
            });
        } catch (error) {
            console.error("Error fetching upload history:", error);
            this.setState({
                uploadHistoryTableData: [],
                snackbarOpen: true,
                snackbarMessage: error.response?.data?.message || "Failed to fetch upload history data",
                snackbarSeverity: "error",
            });
        }
    };

    componentDidMount() {
        console.log("Calling getHistoryTableUploadData");
        this.getHistoryTableUploadData();
        console.log("Calling getApiForClientID");
        this.getApiForClientID();
    }

    fileUploader = (event) => {
        const file = event.target.files[0];
        if (!file) {
            this.setState({
                snackbarOpen: true,
                snackbarMessage: "No file selected",
                snackbarSeverity: "error",
            });
            return;
        }

        if (!file.name.endsWith(".xlsx")) {
            this.setState({
                snackbarOpen: true,
                snackbarMessage: "Please upload an .xlsx file",
                snackbarSeverity: "error",
            });
            return;
        }

        const reader = new FileReader();
        reader.onload = async () => {
            try {
                const file_value = reader.result;
                await axios.post(`/arc/excelupload/daybooks`, {
                    file: file_value,
                    daybook_type: this.state.selectedDaybookType,
                    business_entity_id: parseInt(localStorage.getItem("business_entity_id")),
                });
                this.getHistoryTableUploadData();
                this.setState({
                    snackbarOpen: true,
                    snackbarMessage: "File uploaded successfully",
                    snackbarSeverity: "success",
                });
            } catch (error) {
                console.error("Error uploading file:", error);
                this.setState({
                    error: error?.response?.data?.message || "File upload failed",
                    total_records: 0,
                    snackbarOpen: true,
                    snackbarMessage: error?.response?.data?.message || "File upload failed",
                    snackbarSeverity: "error",
                });
            }
        };
        reader.onerror = () => {
            this.setState({
                snackbarOpen: true,
                snackbarMessage: "Error reading file",
                snackbarSeverity: "error",
            });
        };
        reader.readAsDataURL(file);
    };

    refreshUploadHistoryTable = () => {
        this.getHistoryTableUploadData();
    };

    CollectionListActions = () => (
        <div>
            <a
                href={this.state.selectedDaybookType === "Tally" ? daybookzoho : daybookzoho}
                download={
                    this.state.selectedDaybookType === "Tally"
                        ? "Tally Day book.xlsx"
                        : "Zoho Day book.xlsx"
                }
                style={{ textDecoration: "none" }}
            >
                <Button component="label" size="small" color="primary">
                    <GetAppIcon style={{ fontSize: "20px" }} />
                    DOWNLOAD TEMPLATE
                </Button>
            </a>

            <Button component="label" size="small" color="primary">
                <PublishIcon style={{ fontSize: "20px" }} />
                UPLOAD TEMPLATE
                <input
                    accept=".xlsx"
                    name="file"
                    type="file"
                    value=""
                    hidden
                    onChange={this.fileUploader}
                />
            </Button>

            <Button
                component="label"
                size="small"
                color="primary"
                style={{ float: "right" }}
                onClick={this.refreshUploadHistoryTable}
            >
                <RefreshIcon style={{ fontSize: "20px" }} />
                Refresh
            </Button>
        </div>
    );

    closeUploadData = () => {
        this.setState({ showUploadData: false });
    };

    downloadBase64File = (contentType, base64Data, fileName) => {
        const linkSource = `data:${contentType};base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    };


    uploadReport = (id, pageParam = null) => {
        // Get ID from localStorage if not provided
        let currentId = id;
        if (!currentId) {
            currentId = localStorage.getItem('uploadReportId');
        }

        // If still no ID, show error
        if (!currentId) {
            console.error("uploadReport: Invalid ID", currentId);
            this.setState({ error: "Invalid ID", loading: false });
            return;
        }

        // Store ID in localStorage for future use
        localStorage.setItem('uploadReportId', currentId);

        const page = pageParam !== null ? pageParam : this.state.errorPage;
        const perErrorPages = this.state.perErrorPages || 10;

        if (page < 1 || !Number.isInteger(page)) {
            console.error("uploadReport: Invalid page number", page);
            this.setState({ error: "Invalid page number", loading: false });
            return;
        }

        if (perErrorPages < 1 || !Number.isInteger(perErrorPages)) {
            console.error("uploadReport: Invalid rows per page", perErrorPages);
            this.setState({ error: "Invalid rows per page", loading: false });
            return;
        }

        console.log(`Calling API with id: ${currentId}, page: ${page}, perErrorPages: ${perErrorPages}`);
        console.log(`API URL: /arc/get_data_upload_json/${currentId}/${page}/${perErrorPages}`);

        this.setState({ loading: true, error: null });

        axios
            .get(`/arc/get_data_upload_json/${currentId}/${page}/${perErrorPages}`)
            .then((response) => {
                console.log("API Response:", JSON.stringify(response.data, null, 2));
                const res = response.data.records;

                if (res.type === "json" && res.records && Array.isArray(res.records.details)) {
                    const error_records = res.records.details.filter((v) => v.status === "Fail");
                    this.setState({
                        showUploadData: true,
                        uploadStatusFail: res.records,
                        total_records: parseInt(res.records.summary?.total_records) || 0,
                        successful_records: parseInt(res.records.summary?.valid_records) || 0,
                        error_records: parseInt(res.records.summary?.invalid_records) || 0,
                        errortotal: parseInt(response.data.total) || 0,
                        errorPage: parseInt(response.data.page) || page,
                        perErrorPages: parseInt(response.data.per_page) || perErrorPages,
                        sellerCustomerData: error_records,
                        error: null,
                        loading: false,
                    });
                } else if (res.type === "message") {
                    this.setState({
                        showUploadData: true,
                        uploadStatusFail: res,
                        total_records: 0,
                        successful_records: 0,
                        error_records: 0,
                        errortotal: parseInt(response.data.total) || 0,
                        errorPage: parseInt(response.data.page) || page,
                        perErrorPages: parseInt(response.data.per_page) || perErrorPages,
                        sellerCustomerData: [],
                        error: res.message,
                        loading: false,
                    });
                } else {
                    console.warn("Invalid response format:", res);
                    this.setState({
                        error: "Invalid response format",
                        total_records: 0,
                        loading: false,
                    });
                }
            })
            .catch((error) => {
                console.error("API Error:", error.response || error.message);
                this.setState({
                    loading: false,
                    error: `Failed to fetch data: ${error.message}`,
                });
            });
    };

    // uploadReport = (id) => {
    //     console.log(id);
    //     axios
    //         .get(
    //             `/arc/get_data_upload_json/${id}`
    //         )
    //         .then((response) => {
    //             this.setState({
    //                 showUploadData: true,
    //                 uploadStatusFail: response.data.records,
    //             });

    //             let res = response.data.records.records;
    //             if (response.data.records.type === "json") {
    //                 var error_records = [];
    //                 let promises = res.details.map((v, i) => {
    //                     if (v.status === "Fail") {
    //                         error_records.push(v);
    //                     }
    //                     return true;
    //                 });

    //                 Promise.all(promises).then(() => {
    //                     this.setState({
    //                         total_records: parseInt(res.summary.total_records),
    //                         successful_records: parseInt(res.summary.valid_records),
    //                         error_records: parseInt(res.summary.invalid_records),
    //                         sellerCustomerData: error_records,
    //                         error: null,
    //                     });
    //                     return true;
    //                 });
    //             } else {
    //                 this.setState({
    //                     error: response.data.records.message,
    //                     total_records: 0,
    //                 });
    //             }
    //         })
    //         .catch((error) => {
    //             console.log(error);
    //             this.setState({
    //                 snackbarOpen: true,
    //                 snackbarMessage: "Failed to fetch upload report",
    //                 snackbarSeverity: "error",
    //             });
    //         });
    // };

    handleErpConnectorButton = () => {
        this.setState({ erpConnectorModelOpen: true });
    };

    onClickExport = async (id) => {
        this.setState({ isExportingDaybook: true });
        try {
            const response = await axios.get(
                `/get_daybook_excel/${localStorage.getItem("business_entity_id")}/${id}`
            );
            const contentType =
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            const filename = `${this.state.selectedDaybookType} Daybook.xlsx`;
            this.downloadBase64File(contentType, response.data.file, filename);
            this.setState({
                snackbarOpen: true,
                snackbarMessage: "Exported successfully",
                snackbarSeverity: "success",
            });
        } catch (error) {
            console.error("Error exporting to Excel:", error);
            this.setState({
                snackbarOpen: true,
                snackbarMessage: error?.response?.data?.message || "Failed to export to Excel",
                snackbarSeverity: "error",
            });
        } finally {
            this.setState({ isExportingDaybook: false });
        }
    };

    handleDaybookTypeSelect = (type) => {
        this.setState({
            selectedDaybookType: type,
            erpConnectorName: type === "Zoho" ? this.state.erpConnectorName : "" // Clear erpConnectorName for Tally
        }, () => {
            this.getHistoryTableUploadData();
        });
    };

    onClickExportDaybook = async () => {
        this.setState({ isExportingDaybook: true });
        try {
            const response = await axios.get(
                `/get_daybook_repot/${localStorage.getItem("business_entity_id")}`
            );
            const contentType =
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            const filename = `${this.state.selectedDaybookType} Daybook.xlsx`;
            this.downloadBase64File(contentType, response.data.file, filename);
            this.setState({
                snackbarOpen: true,
                snackbarMessage: "Exported successfully",
                snackbarSeverity: "success",
            });
        } catch (error) {
            console.error("Error exporting to Excel:", error);
            this.setState({
                snackbarOpen: true,
                snackbarMessage: error?.response?.data?.message || "Failed to export to Excel",
                snackbarSeverity: "error",
            });
        } finally {
            this.setState({ isExportingDaybook: false });
        }
    };

    getApiForClientID = async () => {
        try {
            const response = await axios.get(
                `/connection_info/${localStorage.getItem("business_entity_id")}`
            );
            const records = response?.data?.record || [];
            records
                .filter((v) => v.source_system === "ZOHO")
                .forEach((value) =>
                    localStorage.setItem("Client_ID", value.connection_info.client_id)
                );
            records
                .filter((v) => v.source_system === "Effitrac" || v.source_system === "Tally")
                .forEach(() => localStorage.setItem("Trigger_Effitrac/Tally_Button", "true"));
        } catch (error) {
            console.error("Error fetching client ID:", error);
            this.setState({
                snackbarOpen: true,
                snackbarMessage: error?.response?.data?.message || "Failed to fetch connection info",
                snackbarSeverity: "error",
            });
        }
    };

    handleZohoDrawer = () => {
        this.setState({ zohoFlag: 1, openZohoDrawer: true });
    };

    importToCWS = async (dataForFun, uploadType = "Zoho") => {
        this.setState({ importToCwsLoading: true });
        let payLoadData = {};
        if (uploadType === "Zoho") {
            payLoadData = {
                business_entity_id: localStorage.getItem("business_entity_id"),
                daybook_type: "Zoho",
                log_id: localStorage.getItem("zoho_log_id") || "2204",
            };
        }

        try {
            await axios.post("/zoho_day_book/import_cws", payLoadData);
            this.refreshUploadHistoryTable();
            this.setState({
                showUploadHistroyTable: true,
                snackbarOpen: true,
                snackbarMessage: "Data imported successfully",
                snackbarSeverity: "success",
            });
        } catch (error) {
            console.error("Error importing to CWS:", error);
            this.setState({
                snackbarOpen: true,
                snackbarMessage: error?.response?.data?.message || "Failed to import data",
                snackbarSeverity: "error",
            });
        } finally {
            this.setState({ importToCwsLoading: false });
            this.closeErpDrawer();
        }
    };

    closeErpDrawer = () => {
        this.setState({ erpConnectorModelOpen: false });
    };

    establishConnection = (e) => {
        e.preventDefault();
        const clientId = localStorage.getItem("Client_ID");
        if (!clientId || !this.state.url) {
            this.setState({
                snackbarOpen: true,
                snackbarMessage: "Missing Client ID or redirect URL",
                snackbarSeverity: "error",
            });
            return;
        }

        window.location.href = `https://accounts.zoho.in/oauth/v2/auth?scope=ZohoBooks.fullaccess.READ&client_id=${clientId}&state=testing&response_type=code&redirect_uri=${this.state.url}/zohoTesting&access_type=offline&prompt=Consent`;
    };

    closeZohoDrawer = () => {
        if (this.state.timerId) {
            clearInterval(this.state.timerId);
        }
        this.setState({
            zohoDate: {},
            openZohoDrawer: false,
            effitracFormSubmitLoader: false,
            buttonColor: "red",
            messageForConnection: "Establish Connection",
            grantToken: "",
            timerId: null,
        });
    };
zohoDateChangeHandler = (item) => {
  const { name, value } = item;
  const d = new Date(value);
  const newd = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
  const dateValue = newd.toISOString().replace("Z", "");

  this.setState((prevState) => ({
    zohoDate: {
      ...prevState.zohoDate,
      [name]: dateValue,
    },
  }));
};

    fetchingdataForZoho = async () => {
        if (this.state.timerId) {
            clearInterval(this.state.timerId);
        }
        this.setState((prevState) => ({
            zohoFlag: prevState.zohoFlag + 1,
            effitracFormSubmitLoader: true,
        }));

        try {
            const response = await axios.post("/arc/zoho_import", {
                business_entity_id: localStorage.getItem("business_entity_id"),
                code: this.state.grantToken,
                type_of_data: "day_book",
                redirect_uri: `${this.state.url}/zohoTesting`,
                date: this.state.zohoDate,
                auto_sync: this.state.autoSync,
            });

            if (response.data.status === true) {
                this.setState({
                    zohoDate: {},
                    buttonColor: "red",
                    messageForConnection: "Establish Connection",
                    grantToken: "",
                    effitracFormSubmitLoader: false,
                    snackbarOpen: true,
                    snackbarMessage: "Data fetched successfully",
                    snackbarSeverity: "success",
                    autoSync: false,
                });
            } else {
                throw new Error(response.data.message || "Failed to fetch Zoho data");
            }
        } catch (error) {
            console.error("Error fetching Zoho data:", error);
            this.setState({
                zohoDate: {},
                buttonColor: "red",
                messageForConnection: "Establish Connection",
                grantToken: "",
                effitracFormSubmitLoader: false,
                snackbarOpen: true,
                snackbarMessage: error?.response?.data?.message || "Failed to fetch Zoho data",
                snackbarSeverity: "error",
                autoSync: false,
            });
        }
    };

    export_to_excel = async (datafromfunction) => {
        this.setState({ erpDataExportLoading: true });
        let data = {};
        if (!this.state.erpConnectorModelOpen) {
            if (this.state.openZohoDrawer) {
                data = {
                    business_entity_id: localStorage.getItem("business_entity_id"),
                    log_id: localStorage.getItem("zoho_log_id"),
                };
            } else {
                data = {
                    business_entity_id: localStorage.getItem("business_entity_id"),
                };
            }
        } else {
            data = datafromfunction;
        }

        try {
            const response = await axios.post("/zoho_day_book_export/download", data);
            const contentType =
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            const filename = `day_book.xlsx`;
            this.downloadBase64File(contentType, response.data.file, filename);
            this.setState({
                snackbarOpen: true,
                snackbarMessage: "Exported successfully",
                snackbarSeverity: "success",
            });
        } catch (error) {
            console.error("Error exporting to Excel:", error);
            this.setState({
                snackbarOpen: true,
                snackbarMessage: error?.response?.data?.detail || "Failed to export to Excel",
                snackbarSeverity: "error",
            });
        } finally {
            this.setState({ erpDataExportLoading: false });
        }
    };

    export_erp_data_to_excel = async () => {
        this.setState({ erpDataExportLoading: true });
        const payLoadData = {
            business_entity_id: localStorage.getItem("business_entity_id"),
            api_point_name: "vendorpa",
            is_import: true,
        };

        try {
            const response = await axios.post("/arc/get_erp_connector_data", payLoadData);
            if (response?.data?.status) {
                await this.export_to_excel(response.data.data);
                this.setState({
                    snackbarOpen: true,
                    snackbarMessage: "ERP data exported successfully",
                    snackbarSeverity: "success",
                });
            } else {
                throw new Error("Data not found. Please try again later.");
            }
        } catch (error) {
            console.error("Error exporting ERP data:", error);
            this.setState({
                snackbarOpen: true,
                snackbarMessage: error?.response?.data?.message || "Failed to export ERP data",
                snackbarSeverity: "error",
            });
        } finally {
            this.setState({ erpDataExportLoading: false });
        }
    };

    render() {
        return (
            <React.Fragment>
                <>
                    <div style={{ textAlign: "center", marginBottom: "20px" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px" }}>
            {/* Back arrow on the left */}
            <Tooltip title="Back" arrow>
              <IconButton
                onClick={() => this.props.history.push('/Data-Upload')}
                sx={{
                  borderRadius: '50%',
                  padding: '6px',
                  color: '#263238',
                  backgroundColor: '#ffffff',
                  height: '36px',
                  width: '36px',
                  '&:hover': {
                    backgroundColor: '#455a64',
                    color: '#ffffff',
                  },
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                  transition: 'background-color 0.3s ease',
                }}
              >
                <ArrowBackIcon sx={{ fontSize: '20px' }} />
              </IconButton>
            </Tooltip>

                            {/* Center the Zoho and Tally buttons */}
                            <div style={{ display: "flex", justifyContent: "center", gap: "15px", flex: 1 }}>
                                <div
                                    onClick={() => this.handleDaybookTypeSelect("Zoho")}
                                    style={{
                                        cursor: "pointer",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        transition: "all 0.3s",
                                        transform: this.state.selectedDaybookType === "Zoho" ? "scale(1.1)" : "scale(1)",
                                        backgroundColor: this.state.selectedDaybookType === "Zoho" ? "#e3f2fd" : "#ffffff",
                                        border: this.state.selectedDaybookType === "Zoho" ? "3px solid #1976d2" : "3px solid #e0e0e0",
                                        borderRadius: "50%",
                                        width: "50px",
                                        height: "50px",
                                        justifyContent: "center",
                                    }}
                                >
                                    <BusinessIcon
                                        style={{ fontSize: "20px", color: this.state.selectedDaybookType === "Zoho" ? "#1976d2" : "#757575" }}
                                    />
                                    <span
                                        style={{
                                            marginTop: "3px",
                                            fontWeight: this.state.selectedDaybookType === "Zoho" ? "bold" : "normal",
                                            color: this.state.selectedDaybookType === "Zoho" ? "#1976d2" : "#757575",
                                            fontSize: "10px",
                                        }}
                                    >
                                        Zoho
                                    </span>
                                </div>
                                <div
                                    onClick={() => this.handleDaybookTypeSelect("Tally")}
                                    style={{
                                        cursor: "pointer",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        transition: "all 0.3s",
                                        transform: this.state.selectedDaybookType === "Tally" ? "scale(1.1)" : "scale(1)",
                                        backgroundColor: this.state.selectedDaybookType === "Tally" ? "#e3f2fd" : "#ffffff",
                                        border: this.state.selectedDaybookType === "Tally" ? "3px solid #1976d2" : "3px solid #e0e0e0",
                                        borderRadius: "50%",
                                        width: "50px",
                                        height: "50px",
                                        justifyContent: "center",
                                    }}
                                >
                                    <CalculateIcon
                                        style={{ fontSize: "20px", color: this.state.selectedDaybookType === "Tally" ? "#1976d2" : "#757575" }}
                                    />
                                    <span
                                        style={{
                                            marginTop: "3px",
                                            fontWeight: this.state.selectedDaybookType === "Tally" ? "bold" : "normal",
                                            color: this.state.selectedDaybookType === "Tally" ? "#1976d2" : "#757575",
                                            fontSize: "10px",
                                        }}
                                    >
                                        Tally
                                    </span>
                                </div>
                            </div>

                            {/* Export Button aligned to the right */}
                            {/* <Button
                                variant="contained"
                                size="small"
                                onClick={() => this.onClickExportDaybook()}
                                disabled={this.state.erpDataExportLoading}
                                style={{
                                    minWidth: "80px",
                                    height: "36px"
                                }}
                            >
                                {this.state.erpDataExportLoading ? "Exporting..." : "Export"}
                            </Button> */}

                            <button
                                className="button-outlined-primary"
                                style={{
                                    minWidth: "90px",
                                    height: "36px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "6px"
                                }}
                                onClick={() => this.onClickExportDaybook()}
                                disabled={this.state.isExportingDaybook}
                            >
                                {this.state.isExportingDaybook ? (
                                    <>
                                        <span
                                            style={{
                                                width: "12px",
                                                height: "12px",
                                                border: "2px solid currentColor",
                                                borderTopColor: "transparent",
                                                borderRadius: "50%",
                                                display: "inline-block",
                                                animation: "spin 0.7s linear infinite",
                                                flexShrink: 0,
                                            }}
                                        />
                                        Exporting...
                                    </>
                                ) : (
                                    "Export"
                                )}
                            </button>
                        </div>
                    </div>
                    {/* <div style={{ textAlign: "center", marginBottom: "20px" }}>
                        <div style={{ display: "flex", justifyContent: "center", gap: "15px", marginTop: "20px" }}>
                            <div
                                onClick={() => this.handleDaybookTypeSelect("Zoho")}
                                style={{
                                    cursor: "pointer",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    transition: "all 0.3s",
                                    transform: this.state.selectedDaybookType === "Zoho" ? "scale(1.1)" : "scale(1)",
                                    backgroundColor: this.state.selectedDaybookType === "Zoho" ? "#e3f2fd" : "#ffffff",
                                    border: this.state.selectedDaybookType === "Zoho" ? "3px solid #1976d2" : "3px solid #e0e0e0",
                                    borderRadius: "50%",
                                    width: "50px",
                                    height: "50px",
                                    justifyContent: "center",
                                }}
                            >
                                <BusinessIcon
                                    style={{ fontSize: "20px", color: this.state.selectedDaybookType === "Zoho" ? "#1976d2" : "#757575" }}
                                />
                                <span
                                    style={{
                                        marginTop: "3px",
                                        fontWeight: this.state.selectedDaybookType === "Zoho" ? "bold" : "normal",
                                        color: this.state.selectedDaybookType === "Zoho" ? "#1976d2" : "#757575",
                                        fontSize: "10px",
                                    }}
                                >
                                    Zoho
                                </span>
                            </div>
                            <div
                                onClick={() => this.handleDaybookTypeSelect("Tally")}
                                style={{
                                    cursor: "pointer",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    transition: "all 0.3s",
                                    transform: this.state.selectedDaybookType === "Tally" ? "scale(1.1)" : "scale(1)",
                                    backgroundColor: this.state.selectedDaybookType === "Tally" ? "#e3f2fd" : "#ffffff",
                                    border: this.state.selectedDaybookType === "Tally" ? "3px solid #1976d2" : "3px solid #e0e0e0",
                                    borderRadius: "50%",
                                    width: "50px",
                                    height: "50px",
                                    justifyContent: "center",
                                }}
                            >
                                <CalculateIcon
                                    style={{ fontSize: "20px", color: this.state.selectedDaybookType === "Tally" ? "#1976d2" : "#757575" }}
                                />
                                <span
                                    style={{
                                        marginTop: "3px",
                                        fontWeight: this.state.selectedDaybookType === "Tally" ? "bold" : "normal",
                                        color: this.state.selectedDaybookType === "Tally" ? "#1976d2" : "#757575",
                                        fontSize: "10px",
                                    }}
                                >
                                    Tally
                                </span>
                            </div>
                        </div>
                        <button
                            className="button-outlined-primary"
                            style={{
                                width: `${"Submit".length * 8 + 20}px`,
                                minWidth: "90px",
                                height: "36px"
                            }}
                            onClick={() => this.onClickExportDaybook()}
                            disabled={this.state.erpDataExportLoading}
                        >
                            {this.state.erpDataExportLoading ? "Exporting..." : "Export"}
                        </button>
                    </div> */}

                    <div>
                        <BoxWrapper
                            boxTitle="Upload Daybook"
                            zohoEffitracEnable={
                                localStorage.getItem("Client_ID") &&
                                !this.state.isEffitrac &&
                                true
                            }
                            zohoEffitracFn={this.handleZohoDrawer}
                            enableImportToEffTallybutton={
                                localStorage.getItem("Trigger_Effitrac/Tally_Button") &&
                                localStorage.getItem("Trigger_Effitrac/Tally_Button") === "true" &&
                                !this.state.isEffitrac &&
                                true
                            }
                            importToEffiTallyFn={this.import_Effitrac_tally}
                            buttons={[
                                {
                                    label: "Export",
                                    handler: () => this.onClickExportDaybook(),
                                    enabled: true,
                                },
                                ...(this.state.selectedDaybookType === "Zoho" && this.state.erpConnectorName
                                    ? [{
                                    label: this.state.erpConnectorName,
                                    handler: this.handleErpConnectorButton,
                                    enabled: !!this.state.erpConnectorName,
                                    }]
                                    : []),
                            ]}
                        >
                            <>
                                {(localStorage.getItem('is_uploads') !== "N") && (
                                    <div style={{ marginBottom: "10px" }}>
                                        <this.CollectionListActions />
                                    </div>
                                )}
                                <div className="responsive-table">
                                    <table className="custome-table">
                                        <thead>
                                            <tr>
                                                <th>Last Upload Date & Time</th>
                                                <th>Status</th>
                                                <th>Upload Type</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(Array.isArray(this.state.uploadHistoryTableData)
                                                ? this.state.uploadHistoryTableData
                                                : []
                                            ).map((item, i) => {
                                                const isDisabled =
                                                    item.status === "Initiated" ||
                                                    item.status === "In Progress" ||
                                                    item.status === "Uploaded";

                                                return (
                                                    <tr key={i}>
                                                        <td>{item.upload_date}</td>
                                                        <td>{item.status}</td>
                                                        <td>{item.upload_type}</td>
                                                        <td>
                                                            <RemoveRedEyeOutlinedIcon
                                                                className={
                                                                    isDisabled
                                                                        ? "action-icon-button-disabled"
                                                                        : "action-icon-button showIcon"
                                                                }
                                                                color={isDisabled ? "disabled" : "inherit"}
                                                                onClick={
                                                                    isDisabled ? undefined : () => this.uploadReport(item.id)
                                                                }
                                                                style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}
                                                            />
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                            {(!Array.isArray(this.state.uploadHistoryTableData) ||
                                                this.state.uploadHistoryTableData.length === 0) && (
                                                    <tr>
                                                        <td
                                                            colSpan={5}
                                                            style={{ color: "red", textAlign: "center" }}
                                                        >
                                                            No Data Found!
                                                        </td>
                                                    </tr>
                                                )}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        </BoxWrapper>
                    </div>

                    {this.state.showUploadData ? (
                        <>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <div className={classes.Main_frame}>
                                        <div className={classes.form_title_bar}>
                                            <div className="form_title_name">
                                                <ul
                                                    style={{
                                                        listStyle: "none",
                                                        marginBottom: "0px",
                                                        padding: "0px",
                                                        marginTop: "0px",
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <li style={{ fontWeight: "700" }}>Upload Details</li>
                                                    <li>
                                                        <button
                                                            className="close-icon-button"
                                                            onClick={this.closeUploadData}
                                                        >
                                                            <ClearIcon style={{ color: "var(--app-bar-bg)" }} />
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className={classes.form_body_part}>
                                            {this.state.total_records > 0 && (
                                                <div>
                                                    <div style={{ marginLeft: "30px", marginRight: "30px" }}>
                                                        <Grid container spacing={3}>
                                                            <Grid item xs={4}>
                                                                <Card
                                                                    backgroundcolor="#6f9eaf"
                                                                    cardTitle="Total Records"
                                                                    cardBody={this.state.total_records}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                <Card
                                                                    backgroundcolor="#007965"
                                                                    cardTitle="Successful Records"
                                                                    cardBody={this.state.successful_records}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                <Card
                                                                    backgroundcolor="#eb596e"
                                                                    cardTitle="Error Records"
                                                                    cardBody={this.state.error_records}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </div>

                                                    <div
                                                        style={{
                                                            height: "300",
                                                            margin: "20px 30px 0px 30px",
                                                        }}
                                                    >
                                                        <Grid container spacing={3}>
                                                            <Grid item xs={12}>
                                                                <div sx={{ height: 300, mt: 2, overflowY: 'auto', overflowX: 'auto' }}>
                                                                    <MuiThemeProvider>
                                                                        {/* <DataTables
                                                                            columns={this.state.sellerCustomerCol}
                                                                            data={this.state.sellerCustomerData}
                                                                            selectable={false}
                                                                            showRowHover={true}
                                                                            page={1}
                                                                            count={this.state.total_records}
                                                                        /> */}
                                                                        <DataTables
                                                                            columns={this.state.sellerCustomerCol}
                                                                            data={this.state.sellerCustomerData}
                                                                            selectable={false}
                                                                            showRowHover={true}
                                                                            page={this.state.errorPage}
                                                                            count={this.state.errortotal}
                                                                            rowSize={this.state.perErrorPages}
                                                                            showRowSizeControls={true}
                                                                            showFooterToolbar={true}
                                                                            onNextPageClick={this.handleNextPage}
                                                                            onPreviousPageClick={this.handlePreviousPage}
                                                                            onRowSizeChange={this.handleRowsPerPageChange}
                                                                        />
                                                                    </MuiThemeProvider>
                                                                </div>
                                                            </Grid>
                                                        </Grid>
                                                    </div>
                                                </div>
                                            )}
                                            {this.state.error && (
                                                <div style={{ color: "red" }}>
                                                    <ErrorIcon />
                                                    {this.state.error}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </>
                    ) : (
                        ""
                    )}

                    <Snackbar
                        open={this.state.snackbarOpen}
                        autoHideDuration={5000}
                        onClose={this.handleSnackbarClose}
                        anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    >
                        <Alert
                            onClose={this.handleSnackbarClose}
                            severity={this.state.snackbarSeverity}
                            sx={{ width: "100%" }}
                        >
                            {this.state.snackbarMessage}
                        </Alert>
                    </Snackbar>

                    <ZohoModel
                        openZohoDrawer={this.state.openZohoDrawer}
                        buttonColor={this.state.buttonColor}
                        establishConnection={this.establishConnection}
                        messageForConnection={this.state.messageForConnection}
                        timerForZohoInSalesCustomer={this.state.timer}
                        closeZohoDrawer={this.closeZohoDrawer}
                        zohoDateChangeHandler={this.zohoDateChangeHandler}
                        effitracImportFormloader={this.state.effitracFormSubmitLoader}
                        fetchingdataForZoho={this.fetchingdataForZoho}
                        zohoDate={this.state.zohoDate}
                        logApitName="day_book"
                        nameOfTheModel="Day book"
                        importToCWS={this.importToCWS}
                        exportToExcel={this.export_to_excel}
                        zohoTableHeader={this.state.effitracHeader}
                        zohoTableColumn={this.state.effitracCol}
                        drawerKeys={[]}
                        autoSync={this.state.autoSync} // Added autoSync prop
                        setAutoSync={this.handleAutoSyncChange} // Added setAutoSync prop
                    />
                </>
            </React.Fragment>
        );
    }
}

export default withRouter(DaybookManagement);